import React, { createContext, useContext, useMemo } from "react";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import {
  findConceptModule,
  isConceptSubscribed,
} from "../../platform_spaces/space/conceptEntitlement";

type ConceptEntitlementValue = {
  conceptModule: MembershipProduct | null;
  conceptEntitled: boolean;
};

const ConceptEntitlementContext = createContext<ConceptEntitlementValue>({
  conceptModule: null,
  conceptEntitled: false,
});

export function ConceptEntitlementProvider(props: {
  membershipProducts: MembershipProduct[];
  children: React.ReactNode;
}): JSX.Element {
  const { membershipProducts, children } = props;
  const value = useMemo(
    () => ({
      conceptModule: findConceptModule(membershipProducts),
      conceptEntitled: isConceptSubscribed(membershipProducts),
    }),
    [membershipProducts]
  );
  return (
    <ConceptEntitlementContext.Provider value={value}>
      {children}
    </ConceptEntitlementContext.Provider>
  );
}

export function useConceptEntitlement(): ConceptEntitlementValue {
  return useContext(ConceptEntitlementContext);
}
